/**
 * ActivityManager — API du fil d'activité.
 *
 * Expose les entités DR (celles qui portent un `DR_META`, estampé à la capture au
 * dessin), triées par `createdAt`. Délègue au parsing pur `parsing/activity.ts`.
 */

import type { DRDrawingViewer } from "../DRDrawingViewer";
import { listActivityEntities, type ActivityEntity } from "../parsing/activity";

export class ActivityManager {
  constructor(private viewer: DRDrawingViewer) {}

  /** Liste les entités DR, triées par ordre de création. */
  listEntities(): ActivityEntity[] {
    return listActivityEntities(this.viewer);
  }
}
